export const PAYABLES_MOCK = [
  {
    id: -1,
    description: null,
    due: '26/09/2024',
    invoice_number: null,
    total: 'R$ 55,55',
    status: 'Pendente',
    bank_slip_number: null,
    status_id: 0,
    created_at: '25/09/2024',
    supplier: {
      id: 340,
      name: 'Fornecedor',
    },
    total_items: 1,
    payable_items: [
      {
        id: 901,
        item_id: 1812,
        category: {
          id: 191,
          name: 'Terraplanagem',
        },
        description: null,
        unit: null,
        quantity: 0.0,
        total: 55.55,
      },
    ],
    total_attachments: 0,
    attachments: [],
  },
  {
    id: -2,
    description: null,
    due: '26/09/2024',
    invoice_number: null,
    total: 'R$ 1.000,00',
    status: 'Pendente',
    bank_slip_number: null,
    status_id: 0,
    created_at: '24/09/2024',
    supplier: {
      id: 318,
      name: 'Prefeitura',
    },
    total_items: 1,
    payable_items: [
      {
        id: 892,
        item_id: 1823,
        category: {
          id: 175,
          name: 'Prefeitura',
        },
        description: null,
        unit: null,
        quantity: 0.0,
        total: 1000.0,
      },
    ],
    total_attachments: 0,
    attachments: [],
  },
];

export const MOCK_CONSTRUCTIONS = [
  {
    id: 0,
    name: 'Obra Exemplo',
    address: '',
    address2: '',
    city: '',
    state: '',
    starts_at: null,
    ends_at: null,
    finished: false,
    square_meters: null,
    zipcode: '',
    address_num: null,
    description: 'Obra exemplo para o tour guiado',
    facade: null,
    export_key:
      'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOlsxMzksNTBdLCJleHAiOjE3MjgzOTkzMTZ9.hXa4a5KpleXsl7dV2-MLCyP37q6Y61IoKjQQZVCxtj8',
    users: [
      {
        id: 0,
        name: '',
        birthday: null,
        document1: '999999999',
        document2: '11122233345',
        email: 'sioon@email.com',
        address: 'Avenida Brasil',
        city: 'São Paulo',
        state: 'SP',
        phone: '11999999999',
        cellphone: null,
        user_type: 'client',
        zipcode: '00000-000',
        address_num: 33,
        address_details: '',
        company_id: 0,
        has_access: true,
        permissions: [
          'payables',
          'budgets',
          'schedules',
          'dashboard',
          'photos',
          'documents',
        ],
        accepts_whatsapp: true,
        accepts_contents: true,
        is_verified: true,
        verified_at: null,
      },
    ],
    status: 'Em andamento',
    path: null,
  },
];

export const MOCK_HEADER_INFO = {
  id: 0,
  name: 'Obra Tour',
  square_meters: 0,
  total_budget: 5000,
  total_budget_per_m2: 0,
  total_estimate: 3000,
  total_estimate_per_m2: 0,
  total_paid: 1500,
  total_paid_per_m2: 0,
};

export const MOCK_BUDGETS = [
  {
    id: 1812,
    parent_id: null,
    item_num: '1',
    description: 'Orçamento Pedras ',
    unit: '',
    unit_price: 0.0,
    quantity: 0.0,
    price: 460.0,
    price_percentage: 7.718120805369128,
    total_paid: 1950.0,
    paid_percentage: 66.10169491525424,
    total_estimate: 1950.0,
    estimate_percentage: 66.10169491525424,
    is_leaf_node: true,
    has_payables: true,
    is_finalized: false,
    items_attributes: [
      {
        id: 1813,
        parent_id: 1812,
        item_num: '1',
        description: 'Pedra cozinha',
        unit: '12',
        unit_price: 55.0,
        quantity: 2.0,
        price: 110.0,
        price_percentage: 1.8456375838926173,
        total_paid: 1600.0,
        paid_percentage: 54.23728813559322,
        total_estimate: 1600.0,
        estimate_percentage: 54.23728813559322,
        is_leaf_node: true,
        has_payables: true,
        is_finalized: true,
        items_attributes: [],
      },
      {
        id: 1814,
        parent_id: 1812,
        item_num: '2',
        description: 'Pedra lavanderia',
        unit: '1',
        unit_price: 50.0,
        quantity: 3.0,
        price: 150.0,
        price_percentage: 2.5167785234899327,
        total_paid: 150.0,
        paid_percentage: 5.084745762711864,
        total_estimate: 150.0,
        estimate_percentage: 5.084745762711864,
        is_leaf_node: true,
        has_payables: true,
        is_finalized: true,
        items_attributes: [],
      },
      {
        id: 1815,
        parent_id: 1812,
        item_num: '3',
        description: 'Pedras Banheiros',
        unit: null,
        unit_price: 0.0,
        quantity: 0.0,
        price: 200.0,
        price_percentage: 3.3557046979865772,
        total_paid: 200.0,
        paid_percentage: 6.779661016949152,
        total_estimate: 200.0,
        estimate_percentage: 6.779661016949152,
        is_leaf_node: true,
        has_payables: false,
        is_finalized: false,
        items_attributes: [
          {
            id: 1816,
            parent_id: 1815,
            item_num: '1',
            description: 'Banheiro Suite I',
            unit: '1',
            unit_price: 50.0,
            quantity: 2.0,
            price: 100.0,
            price_percentage: 1.6778523489932886,
            total_paid: 100.0,
            paid_percentage: 3.389830508474576,
            total_estimate: 100.0,
            estimate_percentage: 3.389830508474576,
            is_leaf_node: true,
            has_payables: true,
            is_finalized: true,
            items_attributes: [],
          },
          {
            id: 1819,
            parent_id: 1815,
            item_num: '2',
            description: 'Banheiro Suite II',
            unit: '1',
            unit_price: 50.0,
            quantity: 2.0,
            price: 100.0,
            price_percentage: 1.6778523489932886,
            total_paid: 100.0,
            paid_percentage: 3.389830508474576,
            total_estimate: 100.0,
            estimate_percentage: 3.389830508474576,
            is_leaf_node: true,
            has_payables: true,
            is_finalized: true,
            items_attributes: [],
          },
        ],
      },
    ],
  },
  {
    id: 1820,
    parent_id: null,
    item_num: '2',
    description: 'Orçamento Vidros',
    unit: '',
    unit_price: 0.0,
    quantity: 0.0,
    price: 5500.0,
    price_percentage: 92.28187919463087,
    total_paid: 1000.0,
    paid_percentage: 33.898305084745765,
    total_estimate: 1000.0,
    estimate_percentage: 33.898305084745765,
    is_leaf_node: true,
    has_payables: false,
    is_finalized: false,
    items_attributes: [
      {
        id: 1822,
        parent_id: 1820,
        item_num: '1',
        description: 'Vidro Banheiro',
        unit: null,
        unit_price: 0.0,
        quantity: 0.0,
        price: 5500.0,
        price_percentage: 92.28187919463087,
        total_paid: 1000.0,
        paid_percentage: 33.898305084745765,
        total_estimate: 1000.0,
        estimate_percentage: 33.898305084745765,
        is_leaf_node: true,
        has_payables: false,
        is_finalized: false,
        items_attributes: [
          {
            id: 1823,
            parent_id: 1822,
            item_num: '1',
            description: 'Espelho',
            unit: '1',
            unit_price: 5000.0,
            quantity: 1.0,
            price: 5000.0,
            price_percentage: 83.89261744966443,
            total_paid: 1000.0,
            paid_percentage: 33.898305084745765,
            total_estimate: 1000.0,
            estimate_percentage: 33.898305084745765,
            is_leaf_node: true,
            has_payables: true,
            is_finalized: true,
            items_attributes: [],
          },
          {
            id: 1824,
            parent_id: 1822,
            item_num: '2',
            description: 'Box',
            unit: '1',
            unit_price: 500.0,
            quantity: 1.0,
            price: 500.0,
            price_percentage: 8.389261744966444,
            total_paid: 0.0,
            paid_percentage: 0.0,
            total_estimate: 0.0,
            estimate_percentage: 0.0,
            is_leaf_node: true,
            has_payables: false,
            is_finalized: true,
            items_attributes: [],
          },
        ],
      },
    ],
  },
];

export const MOCK_SCHEDULES = [
  {
    id: 1812,
    parent_id: null,
    item_num: '1',
    description: 'Orçamento Pedras',
    unit: '',
    unit_price: '0,00',
    quantity: '0,00',
    price: '460,00',
    total_paid: '1.950,00',
    total_estimate: '1.950,00',
    is_leaf_node: true,
    has_payables: true,
    is_finalized: false,
    schedule_data: [],
  },
  {
    id: 1820,
    parent_id: null,
    item_num: '2',
    description: 'Orçamento Vidros',
    unit: '',
    unit_price: '0,00',
    quantity: '0,00',
    price: '5.500,00',
    total_paid: '1.000,00',
    total_estimate: '1.000,00',
    is_leaf_node: true,
    has_payables: false,
    is_finalized: false,
    schedule_data: [],
  },
  {
    id: 0,
    parent_id: null,
    item_num: '3',
    description: 'Orçamento Ferramentas',
    unit: '',
    unit_price: '0,00',
    quantity: '0,00',
    price: '2.000,00',
    total_paid: '1.000,00',
    total_estimate: '1.000,00',
    is_leaf_node: true,
    has_payables: false,
    is_finalized: false,
    schedule_data: [],
  },
];

export const MOCK_PHOTOS = [
  {
    construction_id: 0,
    id: 0,
    kind: 'picture',
    last_modified: '2024-10-09',
    name: 'Primeiro Andar',
  },
  {
    construction_id: 1,
    id: 1,
    kind: 'picture',
    last_modified: '2024-10-09',
    name: 'Segundo Andar',
  },
];

export const MOCK_DOCUMENTS = [
  {
    construction_id: 0,
    id: 0,
    kind: 'document',
    last_modified: '2024-10-09',
    name: 'Projeto Executivo',
  },
  {
    construction_id: 1,
    id: 1,
    kind: 'document',
    last_modified: '2024-10-09',
    name: 'Projeto Estrutural',
  },
];

export const MOCK_DASHBOARD = {
  pieChartData: [
    {
      category: 'Terranaplagem',
      color: '#FF0000',
      percentage: '40',
    },
    {
      category: 'Prefeitura',
      color: '#00FF00',
      percentage: '30',
    },
    {
      category: 'Equipamentos',
      color: '#0000FF',
      percentage: '30',
    },
  ],
  barChartData: [
    {
      year: 'default',
      monthly_data: [
        {
          accumulated: '1000.0',
          month: 'JAN / 2022',
          total: '1000',
        },
        {
          accumulated: '1000.0',
          month: 'FEV / 2022',
          total: '0.0',
        },
        {
          accumulated: '1000.0',
          month: 'MAR / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'ABR / 2022',
          total: '500.0',
        },
        {
          accumulated: '1500.0',
          month: 'MAI / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'JUN / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'JUL / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'AGO / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'SET / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'OUT / 2022',
          total: '0.0',
        },
        {
          accumulated: '2200.0',
          month: 'NOV / 2022',
          total: '200.0',
        },
        {
          accumulated: '2500.0',
          month: 'DEZ / 2022',
          total: '300.0',
        },
        {
          accumulated: '2500.0',
          month: 'JAN / 2023',
          total: '0.0',
        },
        {
          accumulated: '2500.0',
          month: 'FEV / 2023',
          total: '0.0',
        },
        {
          accumulated: '2500.0',
          month: 'MAR / 2023',
          total: '0.0',
        },
        {
          accumulated: '2600.0',
          month: 'ABR / 2023',
          total: '100.0',
        },
        {
          accumulated: '3000.0',
          month: 'MAI / 2023',
          total: '400.0',
        },
        {
          accumulated: '3000.0',
          month: 'JUN / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'JUL / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'AGO / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'SET / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'OUT / 2023',
          total: '0.0',
        },
        {
          accumulated: '3500.0',
          month: 'NOV / 2023',
          total: '500.0',
        },
        {
          accumulated: '3700.0',
          month: 'DEZ / 2023',
          total: '200.0',
        },
        {
          accumulated: '4000.0',
          month: 'JAN / 2024',
          total: '300.0',
        },
        {
          accumulated: '4000.0',
          month: 'FEV / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000.0',
          month: 'MAR / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000.0',
          month: 'ABR / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000',
          month: 'MAI / 2024',
          total: '0.0',
        },
        {
          accumulated: '4400.0',
          month: 'JUN / 2024',
          total: '400.0',
        },
        {
          accumulated: '4500.0',
          month: 'JUL / 2024',
          total: '100.0',
        },
        {
          accumulated: '4500.0',
          month: 'AGO / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'SET / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'OUT / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'NOV / 2024',
          total: '0.0',
        },
        {
          accumulated: '5500.0',
          month: 'DEZ / 2024',
          total: '1000.0',
        },
      ],
    },
    {
      year: 2022,
      monthly_data: [
        {
          accumulated: '1000.0',
          month: 'JAN / 2022',
          total: '1000',
        },
        {
          accumulated: '1000.0',
          month: 'FEV / 2022',
          total: '0.0',
        },
        {
          accumulated: '1000.0',
          month: 'MAR / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'ABR / 2022',
          total: '500.0',
        },
        {
          accumulated: '1500.0',
          month: 'MAI / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'JUN / 2022',
          total: '0.0',
        },
        {
          accumulated: '1500.0',
          month: 'JUL / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'AGO / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'SET / 2022',
          total: '0.0',
        },
        {
          accumulated: '2000.0',
          month: 'OUT / 2022',
          total: '0.0',
        },
        {
          accumulated: '2200.0',
          month: 'NOV / 2022',
          total: '200.0',
        },
        {
          accumulated: '2500.0',
          month: 'DEZ / 2022',
          total: '300.0',
        },
      ],
    },
    {
      year: 2023,
      monthly_data: [
        {
          accumulated: '2500.0',
          month: 'JAN / 2023',
          total: '0.0',
        },
        {
          accumulated: '2500.0',
          month: 'FEV / 2023',
          total: '0.0',
        },
        {
          accumulated: '2500.0',
          month: 'MAR / 2023',
          total: '0.0',
        },
        {
          accumulated: '2600.0',
          month: 'ABR / 2023',
          total: '100.0',
        },
        {
          accumulated: '3000.0',
          month: 'MAI / 2023',
          total: '400.0',
        },
        {
          accumulated: '3000.0',
          month: 'JUN / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'JUL / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'AGO / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'SET / 2023',
          total: '0.0',
        },
        {
          accumulated: '3000.0',
          month: 'OUT / 2023',
          total: '0.0',
        },
        {
          accumulated: '3500.0',
          month: 'NOV / 2023',
          total: '500.0',
        },
        {
          accumulated: '3700.0',
          month: 'DEZ / 2023',
          total: '200.0',
        },
      ],
    },
    {
      year: 2024,
      monthly_data: [
        {
          accumulated: '4000.0',
          month: 'JAN / 2024',
          total: '300.0',
        },
        {
          accumulated: '4000.0',
          month: 'FEV / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000.0',
          month: 'MAR / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000.0',
          month: 'ABR / 2024',
          total: '0.0',
        },
        {
          accumulated: '4000',
          month: 'MAI / 2024',
          total: '0.0',
        },
        {
          accumulated: '4400.0',
          month: 'JUN / 2024',
          total: '400.0',
        },
        {
          accumulated: '4500.0',
          month: 'JUL / 2024',
          total: '100.0',
        },
        {
          accumulated: '4500.0',
          month: 'AGO / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'SET / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'OUT / 2024',
          total: '0.0',
        },
        {
          accumulated: '4500.0',
          month: 'NOV / 2024',
          total: '0.0',
        },
        {
          accumulated: '5500.0',
          month: 'DEZ / 2024',
          total: '1000.0',
        },
      ],
    },
  ],
  schedules: [
    {
      description: 'Banheiro',
      id: 1,
      status: 'Concluído',
    },
    {
      description: 'Cozinha',
      id: 2,
      status: 'Em andamento',
    },
    {
      description: 'Varanda',
      id: 3,
      status: 'Não iniciado',
    },
  ],
};

export const MOCK_CATEGORIES = [
  {
    id: 0,
    name: 'Mão de Obra',
    color: '#FF0000',
  },
  {
    id: 1,
    name: 'Serviços',
    color: '#00FF00',
  },
  {
    id: 2,
    name: 'Materiais',
    color: '#0000FF',
  },
];
